'use strict';

var addressBase = require('base/checkout/address');
var formValidation = require('../components/formValidation');
var clientSideValidation = require('../components/clientSideValidation');
var phoneValidation = require('../components/phoneValidation');
var floatingLabel = require('../components/floatingLabel');
var scrollAnimate = require('../components/scrollAnimate');
var focusHelper = require('../components/focus');

addressBase.isValidUSPhone = phoneValidation.isValidUSPhone;

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

function manageSubmitShippingBtn() {
    var $form = $('#dwfrm_shipping');
    var isDisabled = $form.find('input, select').filter('.is-invalid:visible').length > 0;

    if (!isDisabled && $('.data-checkout-stage').attr('data-checkout-stage') === 'customer') {
        isDisabled = true;
    }

    if (!isDisabled && $form.find('.shippingCountry').hasClass('ge-country')) {
        isDisabled = true;
    }

    $form.find('.required').find('input, select').filter(':visible').each(function () {
        if (!isDisabled) {
            var value = $(this).val();
            var excludedValid = true;
            var excludeRegExp = $(this).data('pattern-exclude') ? new RegExp($(this).data('pattern-exclude')) : null;
            if (excludeRegExp && $(this).val()) {
                if (excludeRegExp.test($(this).val())) {
                    excludedValid = false;
                }
            }
            isDisabled = !(value && value.length > 0 && this.validity.valid && excludedValid);

            var inputID = $(this).attr('id');
            var isPhoneInput = inputID && inputID.toLowerCase().indexOf('phone') > -1;
            if (!isDisabled && isPhoneInput && phoneValidation.isUSLocale()) {
                var isValidUSPhoneResult = addressBase.isValidUSPhone($(this), 'eq');
                if (!isValidUSPhoneResult) {
                    isDisabled = true;
                }
            }

            // if loqate search, only enable if hidden fields are valid
            if (!isDisabled && $(this).hasClass('shippingAddressOne') && !$(this).hasClass('skip-js-search')) {
                $form.find('.required').find('input, select').filter(':hidden').each(function () {
                    if (!isDisabled) {
                        var hiddenValue = $(this).val();
                        var hiddenExcludedValid = true;
                        var hiddenExcludeRegExp = $(this).data('pattern-exclude') ? new RegExp($(this).data('pattern-exclude')) : null;
                        if (hiddenExcludeRegExp && $(this).val()) {
                            if (hiddenExcludeRegExp.test($(this).val())) {
                                hiddenExcludedValid = false;
                            }
                        }
                        isDisabled = !(hiddenValue && hiddenValue.length > 0 && this.validity.valid && hiddenExcludedValid);

                        var hiddenInputID = $(this).attr('id');
                        var isHiddenPhoneInput = hiddenInputID && hiddenInputID.toLowerCase().indexOf('phone') > -1;
                        if (!isDisabled && isHiddenPhoneInput && phoneValidation.isUSLocale()) {
                            var isValidHiddenUSPhoneResult = addressBase.isValidUSPhone($(this), 'eq');
                            if (!isValidHiddenUSPhoneResult) {
                                isDisabled = true;
                            }
                        }
                    }
                });
            }
        }
    });

    $form.find('input.shippingAddressTwo').filter(':visible').each(function () {
        if (!isDisabled) {
            var value = $(this).val();
            if (value && value.length > 0) {
                var excludedValid = true;
                var excludeRegExp = $(this).data('pattern-exclude') ? new RegExp($(this).data('pattern-exclude')) : null;
                if (excludeRegExp && $(this).val()) {
                    if (excludeRegExp.test($(this).val())) {
                        excludedValid = false;
                    }
                }
                isDisabled = !(this.validity.valid && excludedValid);
            }
        }
    });

    var $submitShippingBtn = $('.submit-shipping');

    $submitShippingBtn.toggleClass('disabled', isDisabled);
    $submitShippingBtn.attr('disabled', isDisabled);
}

function manageSubmitBillingBtn() {
    var $form = $('#dwfrm_billing');
    var isDisabled = $form.find('input, select').filter('.is-invalid:visible').length > 0;

    $form.find('.required').find('input, select').filter(':visible').each(function () {
        if (!isDisabled) {
            var value = $(this).val();
            var excludedValid = true;
            var excludeRegExp = $(this).data('pattern-exclude') ? new RegExp($(this).data('pattern-exclude')) : null;
            if (excludeRegExp && $(this).val()) {
                if (excludeRegExp.test($(this).val())) {
                    excludedValid = false;
                }
            }
            isDisabled = !(value && value.length > 0 && this.validity.valid && excludedValid);

            var inputID = $(this).attr('id');
            var isPhoneInput = inputID && inputID.toLowerCase().indexOf('phone') > -1;
            if (!isDisabled && isPhoneInput && phoneValidation.isUSLocale()) {
                var isValidUSPhoneResult = addressBase.isValidUSPhone($(this), 'eq');
                if (!isValidUSPhoneResult) {
                    isDisabled = true;
                }
            }
        }
    });

    $form.find('input.billingAddressTwo').filter(':visible').each(function () {
        if (!isDisabled) {
            var value = $(this).val();
            if (value && value.length > 0) {
                var excludedValid = true;
                var excludeRegExp = $(this).data('pattern-exclude') ? new RegExp($(this).data('pattern-exclude')) : null;
                if (excludeRegExp && $(this).val()) {
                    if (excludeRegExp.test($(this).val())) {
                        excludedValid = false;
                    }
                }
                isDisabled = !(this.validity.valid && excludedValid);
            }
        }
    });

    var isAgent = $('.agent-secure-payment-btn').length > 0;
    var $visibleAdyenCheckoutFields = $('.adyen-checkout__field').filter(':visible');
    var $paymentMethodSection = $('#dwfrm_billing fieldset .payment-information').parent();

    if (!isAgent) {
        if ($visibleAdyenCheckoutFields.length === 0 && !$paymentMethodSection.hasClass('d-none')) {
            isDisabled = true;
        } else {
            $visibleAdyenCheckoutFields.each(function () {
                var disabledInput = $(this).find('.adyen-checkout__input--disabled').length > 0;
                if (!isDisabled && !disabledInput) {
                    isDisabled = !$(this).hasClass('adyen-checkout__field--valid');
                }
            });
        }
    }

    var $submitPaymentBtn = $('.submit-payment');

    $submitPaymentBtn.toggleClass('disabled', isDisabled);
    $submitPaymentBtn.attr('disabled', isDisabled);
}

function manageSubmitBtns() {
    manageSubmitShippingBtn();
    manageSubmitBillingBtn();
}

addressBase.matchCountryCodes = function () {
    $('.js_country-code-wrapper').each(function () {
        var $wrapper = $(this);
        var countryCodePrefix = $('input[name$=_countryCodePrefix]', $wrapper).val() || '';

        if (countryCodePrefix && countryCodePrefix.length > 1) {
            if ($('select[name$=_countryCodeDropdownPrefix] option[value="' + countryCodePrefix + '"]', $wrapper).length > 0) {
                $('select[name$=_countryCodeDropdownPrefix]', $wrapper).val(countryCodePrefix);
                $('.js_country-code-dropdown', $wrapper).removeClass('d-none');
                $('.js_country-code-input', $wrapper).addClass('d-none');
            } else {
                $('select[name$=_countryCodeDropdownPrefix]', $wrapper).val('OTHER');
                $('.js_country-code-dropdown', $wrapper).addClass('d-none');
                $('.js_country-code-input', $wrapper).removeClass('d-none');
            }
        }
    });
};

function initAddressEvents() {
    $(document)
        .on('click', '.js_toggle-country-code-list', function () {
            // Show dropdown
            var $wrapper = $(this).closest('.js_country-code-wrapper');
            $wrapper.find('.js_country-code-dropdown, .js_country-code-input').toggleClass('d-none');
            var $coutryCodeDropdownPrefix = $wrapper.find('.shippingcountryCodeDropdownPrefix, .billingcountryCodeDropdownPrefix');
            var countryPrefix = $coutryCodeDropdownPrefix.val() || '';
            if (countryPrefix === 'OTHER') {
                countryPrefix = '';
                $coutryCodeDropdownPrefix.val(countryPrefix);
            }
            $wrapper.find('.shippingcountryCodePrefix, .billingcountryCodePrefix').val(countryPrefix).trigger('input');
            manageSubmitBtns();
        })
        .on('change', 'select[name$=_countryCodeDropdownPrefix]', function () {
            var $wrapper = $(this).closest('.js_country-code-wrapper');
            var value = $(this).val();

            if (value === 'OTHER') {
                // Hide dropdown
                $wrapper.find('.js_country-code-dropdown, .js_country-code-input').toggleClass('d-none');
                value = '';
                var oldValue = $wrapper.find('input[name$=_countryCodePrefix]').val() || '';
                $(this).val(oldValue.replace(/[^0-9]/g, ''));
            } else {
                value = '+' + value;
            }

            $wrapper.find('input[name$=_countryCodePrefix]').val(value);
            manageSubmitBtns();
        })
        .on('change', 'select.shippingState, select.billingState', function () {
            manageSubmitBtns();
        });
}

/**
 * returns a formed <option /> element
 * @param {Object} shipping - the shipping object (shipment model)
 * @param {boolean} selected - current shipping is selected (for PLI)
 * @param {order} order - the Order model
 * @param {Object} [options] - options
 * @returns {Object} - the jQuery / DOMElement
 */
function optionValueForAddress(shipping, selected, order, options) {
    var safeOptions = options || {};
    var isBilling = safeOptions.type && safeOptions.type === 'billing';
    var className = safeOptions.className || '';
    var isSelected = selected;
    var isNew = !shipping;
    var isPreferred = safeOptions.isPreferred;
    var primaryMsg = $('.shipping-content').data('primary-msg');
    if (typeof shipping === 'string') {
        return $('<option class="' + className + '" disabled>' + shipping + '</option>');
    }
    var safeShipping = shipping || {};
    var shippingAddress = safeShipping.shippingAddress || {};

    if (isBilling && isNew && !order.billing.matchingAddressId) {
        shippingAddress = order.billing.billingAddress.address || {};
        isNew = false;
        isSelected = true;
        safeShipping.UUID = 'manual-entry';
    }

    var uuid = safeShipping.UUID ? safeShipping.UUID : 'new';
    var optionEl = $('<option class="' + className + '" />');
    optionEl.val(uuid);

    var title;

    if (isNew) {
        title = order.resources.addNewAddress;
    } else {
        title = [];
        if (isPreferred) {
            title.push(primaryMsg + ' ');
        }
        if (shippingAddress.firstName) {
            title.push(shippingAddress.firstName);
        }
        if (shippingAddress.lastName) {
            title.push(shippingAddress.lastName);
        }
        if (shippingAddress.address1) {
            title.push(', ' + shippingAddress.address1);
        }
        if (shippingAddress.address2) {
            title.push(shippingAddress.address2);
        }
        title.push(', ');
        if (shippingAddress.city) {
            title.push(shippingAddress.city + ', ');
        }
        if (shippingAddress.stateCode) {
            title.push(shippingAddress.stateCode);
        }
        if (shippingAddress.postalCode) {
            title.push(shippingAddress.postalCode);
        }
        if (shippingAddress.countryCodePrefix) {
            title.push(shippingAddress.countryCodePrefix);
        }
        if (!isBilling && safeShipping.selectedShippingMethod) {
            title.push('-');
            title.push(safeShipping.selectedShippingMethod.displayName);
        }

        if (title.length > 2) {
            title = title.join(' ');
        } else {
            title = order.resources.newAddress;
        }
    }
    optionEl.text(title);

    var keyMap = {
        'data-first-name': 'firstName',
        'data-last-name': 'lastName',
        'data-address1': 'address1',
        'data-address2': 'address2',
        'data-city': 'city',
        'data-state-code': 'stateCode',
        'data-postal-code': 'postalCode',
        'data-country-code': 'countryCode',
        'data-phone': 'phone',
        'data-email': 'email',
        'data-country-code-prefix': 'countryCodePrefix',
        'data-country-code-dropdown-prefix': 'countryCodeDropdownPrefix'
    };
    $.each(keyMap, function (key) {
        var mappedKey = keyMap[key];
        var mappedValue = shippingAddress[mappedKey];
        // In case of country code
        if (mappedValue && typeof mappedValue === 'object') {
            mappedValue = mappedValue.value;
        }

        optionEl.attr(key, mappedValue || '');
    });

    var giftObj = {
        'data-is-gift': 'isGift',
        'data-gift-message': 'giftMessage'
    };

    $.each(giftObj, function (key) {
        var mappedKey = giftObj[key];
        var mappedValue = safeShipping[mappedKey];
        optionEl.attr(key, mappedValue || '');
    });

    if (isSelected) {
        optionEl.attr('selected', true);
    }

    return optionEl;
}

/**
 * Validate States base on country selector
 * @param {string} selector country selector
 */
function validateCountryStates(selector) {
    var $form = $(selector).closest('form');
    var countryCode = $(selector).val();
    var preferenecs = $(selector).data('preferences');

    if (typeof preferenecs === 'string') {
        try {
            preferenecs = JSON.parse(preferenecs);
        } catch (e) {
            return;
        }
    }

    if (preferenecs) {
        var countryPref = preferenecs[countryCode];
        var $state = $form.find('[name$="_stateCode"]');
        if (countryPref && countryPref.state.required) {
            $state.prop('required', true);
            $state.attr('aria-required', 'true');
        } else {
            $state.prop('required', false);
            $state.removeAttr('aria-required');
            $state.parent().find('.invalid-feedback').hide();
            $state.parent().find('.form-control').removeClass('is-invalid');
        }
        if (countryPref && countryPref.postalCode.regex) {
            $form.find('input[name$=_postalCode]').attr('pattern', countryPref.postalCode.regex);
        }
    }
}

addressBase.triggerAddressEvents = function () {
    $('input[name$=addressType]').on('change', function () {
        var $form = $(this).closest('form');
        var $addressSelect = $form.find('.addressSelector');
        if ($(this).val() === 'newAddress') {
            var preSelectedID = $addressSelect.find('option:checked').val();
            $(this).closest('.select-shipping-address-type').data('pre-select', preSelectedID);
            $form.find('.btn-add-new').trigger('click');
            $form.find('.form-control-label').removeClass('form-control-label--float-up');
            $form.find('.contact-info-block, .payment-form-fields').find('.form-control-label').addClass('form-control-label--float-up');
            $form.find('.js_country-code-dropdown').removeClass('d-none').find('select').val('');
            $form.find('.js_country-code-input').addClass('d-none').find('input').val('');
            clientSideValidation.functions.clearForm($form);
            validateCountryStates($form.find('select[name$=_country]'));
            ['.shippingCountry', '.billingCountry'].forEach(function (selector) {
                if ($(selector).val() === '') {
                    $(selector).closest('div').find('.flag-icon-rounded').removeClass('flag-icon-rounded');
                }
            });
            $('.toogle-addr-search .search:not(.d-none)').trigger('click');
        } else {
            var preSelect = $(this).closest('.select-shipping-address-type').data('pre-select');
            var $newEl = $('option[value$="' + preSelect + '"]', $addressSelect);
            $newEl.prop('selected', 'selected');
            $newEl.parent().trigger('change');
        }
        floatingLabel.refreshFloatingLabels();
        manageSubmitBtns();
    });

    $(document).on('keypress', '.select-shipping-address-type.custom-radio-select-wrapper .custom-control-label', function (event) {
        if (event.key === 'Enter') {
            event.preventDefault();

            var $input = $(this).closest('.custom-radio-wrapper').find('.custom-control-input');
            if ($input && $input.length) {
                $input[0].click();

                if ($(this).parents('.select-shipping-address-type-new').length) {
                    $('.select-shipping-address-type.custom-radio-select-wrapper .select-shipping-address-type-saved .custom-control-label').focus();
                } else if ($(this).parents('.select-shipping-address-type-saved').length) {
                    $('.select-shipping-address-type.custom-radio-select-wrapper .select-shipping-address-type-new .custom-control-label').focus();
                }
            }
        }
    });

    $(document).on('keydown', '.toogle-addr-search', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            $(this).click();
        }
    });

    $(document).on('change', '.addressSelector', function () {
        var selected = $(this).find('option:selected');
        var countryCode = selected.data('country-code');
        var $form = $(this).closest('form');
        var $countrySelect = $form.find('select[name$="_country"]');
        if ($countrySelect.length && countryCode) {
            $countrySelect.val(countryCode).trigger('change');
            validateCountryStates($countrySelect);
        }
    });
};

addressBase.billingAddress = function () {
    $('#useShippingAddressForBilling').on('change', function () {
        var $form = $(this).closest('form');
        $form.find('.billing-address').find('.invalid-feedback').hide();
        $form.find('.billing-address').find('input, select').removeClass('is-invalid');
        $form.find('.billing-address').find('.form-control-label').removeClass('form-control-label--float-up');
        var $addressSelect = $form.find('.addressSelector');
        $form.find('.billing-address').addClass('new-address');
        var optionValue;
        if (this.checked) {
            optionValue = $('input[name=originalShipmentUUID]').val();
            $addressSelect.find('option[value$="' + optionValue + '"]').prop('selected', 'selected');
            $addressSelect.trigger('change');
            $form.find('.billing-address').removeClass('new-address');
            $('.billing-address-block').addClass('d-none');
        } else if ($(this).data('addressbook')) {
            optionValue = $form.find('.select-shipping-address-type').data('pre-select');
            $form.find('input#billing_savedAddress').prop('checked', true);
            $addressSelect.find('option[value$="' + optionValue + '"]').prop('selected', 'selected');
            $addressSelect.trigger('change');
            $('.billing-address-block').removeClass('d-none');
        } else {
            $form.find('.btn-add-new').trigger('click');
            $('.billing-address-block').removeClass('d-none');
            var $billingCountry = $('.billingCountry');
            var defaultCountryCode = $billingCountry.data('country-code');
            $billingCountry.val(defaultCountryCode);

            if (!defaultCountryCode) {
                var parent = $billingCountry.closest('form');
                var icon = parent.find('.flag-icon-background');
                icon.removeClass().addClass('flag-icon-background');
                icon.closest('div').removeClass('flag-padding');
            }

            $form.find('.js_country-code-dropdown').removeClass('d-none').find('select').val('');
            $form.find('.js_country-code-input').addClass('d-none').find('input').val('');
        }
        floatingLabel.refreshFloatingLabels();
        manageSubmitBillingBtn();
    });
};

addressBase.showDetails = function () {
    $('.btn-show-details').on('click', function () {
        var root = $(this).closest('.shipping-content');
        var selectedOption = $('.addressSelector option:selected', root);
        var attrs = selectedOption.data();
        Object.keys(attrs).forEach(function (attr) {
            var element = attr === 'countryCode' ? 'country' : attr;
            $('.edit-saved-address [name$=' + element + ']', root).val(attrs[attr]);
        });
        $('.edit-saved-address [name=makeDefaultAddress]', root).prop('checked', attrs.isPreferred);
        var $modal = $('.edit-saved-address', root);
        if (attrs.isPreferred) {
            $('.make-default-address', $modal).addClass('d-none');
        } else {
            $('.make-default-address', $modal).removeClass('d-none');
        }
        validateCountryStates($modal.find('[name$=_country]'));
        if ($('.shippingcountryCodePrefix').val() !== '') {
            $('.message-desc').addClass('d-none');
        } else {
            $('.message-desc').removeClass('d-none');
        }
        $modal.modal('show');
    });
};

addressBase.clearErrors = function () {
    $('.edit-saved-address').on('hidden.bs.modal shown.bs.modal', function () {
        clientSideValidation.functions.clearForm($(this).find('form'));
        floatingLabel.refreshFloatingLabels();
    });
};

addressBase.saveChanges = function () {
    $('.save-address').on('submit', function (e) {
        e.preventDefault();
        var root = $(this).closest('.shipping-content');
        var form = $(this);
        var selectedOption = $('.addressSelector option:selected', root);
        var attrs = selectedOption.data();
        var url = $(this).attr('action');
        var urlParams = {
            addressId: attrs.addressId
        };

        if (form.find('.shippingCountry').hasClass('ge-country')) {
            return;
        }

        url = appendToUrl(url, urlParams);
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'POST',
            data: form.serialize(),
            dataType: 'json',
            success: function (data) {
                if (!data.success) {
                    formValidation(form, data);
                } else {
                    if (data.isPreferred) {
                        $('.addressSelector option', root).data('is-preferred', false);
                    }
                    Object.keys(attrs).forEach(function (attr) {
                        if (attr === 'stateCode' && data.states) {
                            selectedOption.data(attr, data.states.stateCode || '');
                        } else if (attr === 'countryCode') {
                            selectedOption.data(attr, data.country);
                        } else {
                            selectedOption.data(attr, data[attr]);
                        }
                    });
                    var updatedAddressString;
                    var primaryMsg = $('.shipping-content').data('primary-msg');
                    if (data.isPreferred) {
                        var unSelectedOption = $('.addressSelector option:not(selected)', root);
                        unSelectedOption.each(function (index, value) {
                            var $option = $(value);
                            if (!$option.attr('disabled')) {
                                $option.html($(this).data('first-name') + ' ' + $(this).data('last-name') + ', ' + $(this).data('address1') + ' ' + ($(this).data('address2') || '') + ', ' + $(this).data('city') + ', ' + $(this).data('state-code') + ' ' + $(this).data('postal-code'));
                            }
                        });
                        updatedAddressString = primaryMsg + ' ' + attrs.firstName + ' ' + attrs.lastName + ', ' + attrs.address1 + ' ' + (attrs.address2 || '') + ', ' + attrs.city + ', ' + attrs.stateCode + ' ' + attrs.postalCode;
                    } else {
                        updatedAddressString = attrs.firstName + ' ' + attrs.lastName + ', ' + attrs.address1 + ' ' + (attrs.address2 || '') + ', ' + attrs.city + ', ' + attrs.stateCode + ' ' + attrs.postalCode;
                    }
                    selectedOption.html(updatedAddressString);
                    root.find('.addressSelector').trigger('change');
                    form.closest('.modal').modal('hide');
                }
            }
        }).always(function () {
            $.spinner().stop();
        });
    });
};

addressBase.initiateStates = function () {
    $('select[name$="_country"]').each(function () {
        validateCountryStates(this);
    });
};

addressBase.validateStates = function () {
    $('select[name$="_country"]').on('change', function () {
        validateCountryStates(this);
    });
};

function toggleAddressSuggestions(flag) {
    if (flag) {
        $('.pca').css('visibility', 'hidden');
    } else {
        $('.pca').css('visibility', 'visible');
    }
}

addressBase.formatPhoneNumber = phoneValidation.formatPhoneNumber;

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} form - Event to be canceled if form is invalid.
 * @param {boolean} isIgnoreZipValidation - zip code validation ignored for saved address.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(form, isIgnoreZipValidation) {
    var valid = true;
    var isUS = phoneValidation.isUSLocale();
    var inputs = form && form.find('input, select');
    var formError = form && form.find('.form-error');
    if (!inputs || inputs.length === 0) {
        return false;
    }

    inputs.each(function () {
        var $field = $(this);

        // Skip validation for fields that are in hidden containers (e.g., country code input when dropdown is visible)
        if ($field.closest('.d-none').length > 0) {
            return; // continue to next field
        }

        var validationMessage;
        var value = $field.val();
        var inputID = $field.attr('id');
        var isPhoneInput = inputID && inputID.toLowerCase().indexOf('phone') > -1;
        var excludedValid = true;
        var excludeRegExp = $field.data('pattern-exclude') ? new RegExp($field.data('pattern-exclude')) : null;

        if (excludeRegExp && value) {
            if (excludeRegExp.test(value)) {
                excludedValid = false;
            }
        }

        if ((!this.validity.valid && !$field.hasClass('adyen-checkout__card__holderName__input') && (!isIgnoreZipValidation || (isIgnoreZipValidation && !$field.hasClass('billingZipCode')))) || !excludedValid) {
            validationMessage = this.validationMessage;
            var patternExclude = $field.hasClass('pattern-exclude');
            var $currentField = $field;
            var $currentFeedback = $currentField.siblings('.invalid-feedback');

            // Generate unique ID for error message
            var currentFieldName = $currentField.attr('name') || $currentField.attr('id') || '';
            var currentErrorId = 'error-' + currentFieldName.replace(/[[\].]/g, '-');

            // Set ARIA attributes immediately when field is invalid
            $currentFeedback.attr('id', currentErrorId);
            $currentField.attr('aria-invalid', 'true');

            $currentFeedback.show();
            $currentField.addClass('is-invalid');

            if ((this.validity.patternMismatch && $field.data('pattern-mismatch') && !patternExclude) || !excludedValid) {
                validationMessage = $field.data('pattern-mismatch');
            } else if (this.validity.valueMissing && $field.data('missing-error')) {
                validationMessage = $field.data('missing-error');
            }
        }

        if (isUS && isPhoneInput && !validationMessage && value.length) {
            var isValidUSPhoneResult = addressBase.isValidUSPhone($field, 'eq');
            var countryCodeErrorMessage = $field.data('countrycode-error-message');
            if (countryCodeErrorMessage && !isValidUSPhoneResult) {
                validationMessage = countryCodeErrorMessage;
            }
        }

        if (validationMessage) {
            valid = false;
            var labelInvalidFeedback = $field.siblings('.invalid-feedback');

            // Update error message HTML (ARIA attributes already set above)
            labelInvalidFeedback.html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + validationMessage + '</span>');

            if ($field.hasClass('countryCodePrefix')) {
                $field.closest('form').attr('data-address-mode', 'details');
                floatingLabel.loadFloatingLabel();
                scrollAnimate($('.countryCodePrefix'));
            }
        }
    });

    var $shippingCountry = form.find('.shippingCountry');
    if ($shippingCountry && $shippingCountry.hasClass('ge-country')) {
        var geCountryErrorMsg = $shippingCountry.data('globale-error-message');
        if (geCountryErrorMsg) {
            valid = false;
            var labelInvalidFeedback = $shippingCountry.siblings('.invalid-feedback');
            labelInvalidFeedback.html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + geCountryErrorMsg + '</span>');
        }
    }

    if (!valid) {
        formError.show().html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + (formError.data('error')) + '</span>');
        if (form && form.find('.toogle-addr-search .manual:visible').length) form.find('.toogle-addr-search .manual:visible').trigger('click');

        var $firstError = form.find('input.is-invalid, select.is-invalid, textarea.is-invalid').first();
        var firstErrMsg = $firstError.siblings('.invalid-feedback').find('span').last().text();
        if (firstErrMsg && !window.pmAnnouncePending) {
            window.pmAnnouncePending = true;
            setTimeout(function () { window.pmAnnouncePending = null; }, 300);
            var $alertEl = $('<div>', { role: 'alert', 'aria-atomic': 'true' })
                .addClass('sr-only')
                .css('text-transform', 'none')
                .text(firstErrMsg);
            $('body').append($alertEl);
            setTimeout(function () { $alertEl.remove(); }, 1500);
        }

        // Move focus to first field with error for accessibility
        // Only select actual form fields (input, select, textarea), not containers
        // For select fields, check if not disabled and element/parent not hidden via d-none class or display:none
        var $allInvalidFields = form.find('input.is-invalid, select.is-invalid, textarea.is-invalid');
        var $firstInvalidField = null;

        // Iterate through invalid fields in DOM order to find the first visible one
        $allInvalidFields.each(function () {
            var $this = $(this);

            // Skip if disabled
            if ($this.prop('disabled') || $this.is(':disabled')) {
                return true; // continue to next
            }

            // Check if element has d-none class
            if ($this.hasClass('d-none')) {
                return true; // continue to next
            }

            // Check if any parent up to the form has d-none class
            var $parents = $this.parentsUntil(form);
            var hasHiddenParent = false;
            for (var i = 0; i < $parents.length; i++) {
                if ($($parents[i]).hasClass('d-none')) {
                    hasHiddenParent = true;
                    break;
                }
            }
            if (hasHiddenParent) {
                return true; // continue to next
            }

            // Check computed display and visibility
            var display = $this.css('display');
            var visibility = $this.css('visibility');
            if (display === 'none' || visibility === 'hidden') {
                return true; // continue to next
            }

            // For select elements, DO NOT check offsetParent as it may be unreliable
            // Instead, rely on the other visibility checks above
            // The offsetParent check was causing select fields to be incorrectly filtered out

            // Found the first visible invalid field!
            $firstInvalidField = $this;
            return false; // break the loop
        });

        // Fallback: if no field found with strict filter, try a simpler approach
        if (!$firstInvalidField || $firstInvalidField.length === 0) {
            $allInvalidFields.each(function () {
                var $this = $(this);
                // Only check if not disabled and not in a hidden parent
                if (!$this.prop('disabled') && !$this.closest('.d-none').length && $this.css('display') !== 'none') {
                    $firstInvalidField = $this;
                    return false; // break the loop
                }
                return true; // continue to next
            });
        }

        // Ensure we have a jQuery object
        if ($firstInvalidField && !$firstInvalidField.jquery) {
            $firstInvalidField = $($firstInvalidField);
        }

        if ($firstInvalidField && $firstInvalidField.length > 0) {
            // Scroll to the field first
            scrollAnimate($firstInvalidField);

            // Set focus with multiple fallback attempts
            setTimeout(function () {
                var field = $firstInvalidField.get(0);
                if (field) {
                    // Make field focusable if needed
                    if (!$firstInvalidField.attr('tabindex')) {
                        $firstInvalidField.attr('tabindex', '-1');
                    }

                    // Direct focus attempt
                    field.focus();

                    // Fallback: use focusWithPolling if direct focus didn't work
                    setTimeout(function () {
                        if (document.activeElement !== field) {
                            focusHelper.focusWithPolling($firstInvalidField, {
                                intervalMs: 50,
                                maxAttempts: 20,
                                ensureTabindex: true
                            });
                        }
                    }, 50);
                }
            }, 200);
        }
    } else {
        formError.hide();
    }

    return valid;
}

/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
function clearFormErrors(form) {
    $(form).find('.form-control.is-invalid').each(function () {
        $(this)
            .removeClass('is-invalid')
            .removeAttr('aria-invalid')
            .removeAttr('aria-describedby');
    });
    $(form).find('.invalid-feedback').hide();
}

addressBase.validateForm = validateForm;

addressBase.validateAddressFields = function () {
    $('.shippingFirstName,.billingFirstName,.shippingLastName,.billingLastName,.shippingAddressOne,.billingAddressOne,.shippingAddressTwo,.billingAddressTwo,.shippingAddressCity,.billingAddressCity,.shippingZipCode,.billingZipCode,.shippingEmail,.email,.shippingPhoneNumber,.phone,.shippingcountryCodePrefix,.billingcountryCodePrefix,.shippingCountry').on('keypress keydown', function () {
        var $field = $(this);
        var labelInvalidFeedback = $field.siblings('.invalid-feedback');
        if ($field.attr('maxlength') && $field.val().length >= $field.attr('maxlength')) {
            var validationMessage = $field.data('maxlength-error-message');
            var fieldName = $field.attr('name') || $field.attr('id') || '';
            var errorId = 'error-' + fieldName.replace(/[[\].]/g, '-');

            labelInvalidFeedback.attr('id', errorId);
            $field.addClass('is-invalid')
                .attr('aria-invalid', 'true');
            labelInvalidFeedback.html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + validationMessage + '</span>').show();

            $('.pcanotification').css('opacity', 0);
        } else {
            $('.pcanotification').css('opacity', 100);
        }

        toggleAddressSuggestions($field.hasClass('is-invalid'));
        manageSubmitBtns();
    })
        .on('input', function () {
            var validationMessage;
            var $field = $(this);
            var value = $field.val();
            var inputID = $field.attr('id');
            var isPhoneInput = inputID && inputID.toLowerCase().indexOf('phone') > -1;
            var isUS = phoneValidation.isUSLocale();

            if (!$field.attr('maxlength') || ($field.attr('maxlength') && value.length < $field.attr('maxlength'))) {
                $field.removeClass('is-invalid')
                    .removeAttr('aria-invalid')
                    .removeAttr('aria-describedby')
                    .siblings('.invalid-feedback')
                    .hide();
            }

            if (isUS && isPhoneInput && value.length) {
                var isValidUSPhoneResult = addressBase.isValidUSPhone($field, 'lteq');
                var countryCodeErrorMessage = $field.data('countrycode-error-message');
                if (countryCodeErrorMessage && !isValidUSPhoneResult) {
                    validationMessage = countryCodeErrorMessage;
                }
            }

            if (validationMessage) {
                var fieldName = $field.attr('name') || $field.attr('id') || '';
                var errorId = 'error-' + fieldName.replace(/[[\].]/g, '-');
                var labelInvalidFeedback = $field.siblings('.invalid-feedback');

                labelInvalidFeedback.attr('id', errorId);
                $field.addClass('is-invalid')
                    .attr('aria-invalid', 'true');

                labelInvalidFeedback
                    .html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + validationMessage + '</span>')
                    .show();
            }

            toggleAddressSuggestions($field.hasClass('is-invalid'));
            manageSubmitBtns();
        })
        .on('blur', function () {
            var validationMessage;
            var labelInvalidFeedback;
            var $field = $(this);

            if (!this.validity.valid && this.validity.valueMissing) {
                validationMessage = $field.attr('data-missing-error') || this.validationMessage;
                var fieldName = $field.attr('name') || $field.attr('id') || '';
                var errorId = 'error-' + fieldName.replace(/[[\].]/g, '-');

                labelInvalidFeedback = $field.siblings('.invalid-feedback');
                labelInvalidFeedback.attr('id', errorId);
                $field.addClass('is-invalid')
                    .attr('aria-invalid', 'true');
                labelInvalidFeedback.html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + validationMessage + '</span>').show();
            }

            var value = $(this).val();
            var inputID = $(this).attr('id');
            var isPhoneInput = inputID && inputID.toLowerCase().indexOf('phone') > -1;
            var isUS = phoneValidation.isUSLocale();
            if (value.length > 0) {
                var excludeRegExp = $(this).data('pattern-exclude') ? new RegExp($(this).data('pattern-exclude')) : null;
                var excludedValid = true;
                if (excludeRegExp && value) {
                    excludedValid = !excludeRegExp.test(value);
                }

                if (!(this.validity.valid && excludedValid)) {
                    validationMessage = this.validationMessage;
                    var patternExclude = $(this).hasClass('pattern-exclude');
                    if ((this.validity.patternMismatch && $(this).data('pattern-mismatch') && !patternExclude) || !excludedValid) {
                        validationMessage = $(this).data('pattern-mismatch');
                    }
                }

                if (isUS && isPhoneInput) {
                    var isValidUSPhoneResult = addressBase.isValidUSPhone($(this), 'eq');
                    var countryCodeErrorMessage = $(this).data('countrycode-error-message');
                    if (countryCodeErrorMessage && !isValidUSPhoneResult) {
                        validationMessage = countryCodeErrorMessage;
                    }
                }

                if (validationMessage) {
                    $(this).addClass('is-invalid').siblings('.invalid-feedback').show();
                    labelInvalidFeedback = $(this).siblings('.invalid-feedback');
                    labelInvalidFeedback.html('<i class="fa fa-exclamation-circle error-message-icon" aria-hidden="true"></i><span>' + validationMessage + '</span>');
                } else if (isPhoneInput) {
                    addressBase.formatPhoneNumber($(this));
                }
            }

            toggleAddressSuggestions(false);
            manageSubmitBtns();
        });

    $('button.submit-shipping').on('click', function () {
        var defer = $.Deferred(); // eslint-disable-line
        var $form = $('#dwfrm_shipping');
        var isIgnoreZipValidation = false;
        var isValidForm = validateForm($form, isIgnoreZipValidation);
        if (!isValidForm) {
            defer.reject();
            manageSubmitShippingBtn();
            return defer;
        }
        clearFormErrors($form);
        return true;
    });

    $('button.submit-payment').on('click', function () {
        var $form = $('#dwfrm_billing');
        var useShippingAddressForBilling = $form.find('.billing-address-block');
        var $addressSelect = $form.find('.addressSelector');
        if (useShippingAddressForBilling && useShippingAddressForBilling.hasClass('d-none') && $addressSelect) {
            var optionValue = $('input[name=originalShipmentUUID]').val();
            $addressSelect.find('option[value$="' + optionValue + '"]').prop('selected', 'selected');
            $addressSelect.trigger('change');
        }
        var isIgnoreZipValidation = false;
        if (useShippingAddressForBilling && useShippingAddressForBilling.hasClass('d-none')) {
            isIgnoreZipValidation = true;
        } else if ($form && $form.attr('data-address-mode') !== 'new') {
            isIgnoreZipValidation = true;
        }
        var isValidForm = validateForm($form, isIgnoreZipValidation);
        if (!isValidForm) {
            if ($addressSelect) {
                $addressSelect.addClass('is-invalid');
            }
            manageSubmitBillingBtn();
            return false;
        }
        return true;
    });

    // PM-1542
    if (!phoneValidation.isUSLocale()) {
        $('.billingCountry, .billingAddressOne, .billingAddressTwo, .billingZipCode').on('change blur focus input click keypress', function () {
            if ($('.billingCountry').val() === 'US') {
                $('.billing-state-field').removeClass('d-none');
            } else {
                $('.billing-state-field').addClass('d-none');
                $('.billingState').val('');
            }

            if ($(this).hasClass('billingCountry')) {
                var selectedCountry = $(this).val();
                var $form = $(this).closest('form');
                var isCountryUS = selectedCountry && selectedCountry.toLowerCase() === 'us';
                var $billingZipInput = $form.find('input#billingZipCode');
                var $billingZipLabel = $form.find('label[for=billingZipCode]');
                var zipLabelText = null;
                var missingZipError = null;

                if (isCountryUS) {
                    zipLabelText = $billingZipLabel && $billingZipLabel.length > 0 ? $billingZipLabel.data('postal-code-label-us') : null;
                    missingZipError = $billingZipInput && $billingZipInput.length > 0 ? $billingZipInput.data('missing-error-us') : null;
                } else {
                    zipLabelText = $billingZipLabel && $billingZipLabel.length > 0 ? $billingZipLabel.data('postal-code-label') : null;
                    missingZipError = $billingZipInput && $billingZipInput.length > 0 ? $billingZipInput.data('missing-error-default') : null;
                }

                if (zipLabelText && zipLabelText.length > 0) {
                    $billingZipLabel.text(zipLabelText);
                }
                if (missingZipError && missingZipError.length > 0) {
                    $billingZipInput.attr('data-missing-error', missingZipError);

                    if ($billingZipInput.hasClass('is-invalid')) {
                        var billingZipInput = $billingZipInput.get(0);
                        if (billingZipInput && billingZipInput.validity && !billingZipInput.validity.valid && billingZipInput.validity.valueMissing) {
                            $billingZipInput.siblings('.invalid-feedback').find('span').text(missingZipError);
                        }
                    }
                }
            }
        });

        $('.countryCodePrefix').on('blur', function () {
            var customMsg = $(this).data('custom-msg');
            $('#defaultcountryCodePrefix span').text(customMsg);
            $('.message-desc').addClass('d-none');
        });

        if ($('.countryCodePrefix').hasClass('is-invalid') || $('#countryCodePrefix').val() !== '') {
            $('.message-desc').addClass('d-none');
        } else {
            $('.message-desc').removeClass('d-none');
        }
    }
};

addressBase.methods.optionValueForAddress = optionValueForAddress;
addressBase.methods.manageSubmitBtns = manageSubmitBtns;
addressBase.methods.manageSubmitBillingBtn = manageSubmitBillingBtn;
addressBase.methods.manageSubmitShippingBtn = manageSubmitShippingBtn;
addressBase.initEvents = function () {
    manageSubmitBtns();
    initAddressEvents();
};

module.exports = addressBase;
